// extracted by mini-css-extract-plugin
export var colorSquare = "_ty-0";
export var danger = "_ty-5";
export var lightPink = "_ty-8";
export var neutralBlue = "_ty-7";
export var neutralYellow = "_ty-6";
export var normal = "_ty-1";
export var primary = "_ty-2";
export var primaryLight = "_ty-3";
export var solidBlack = "_ty-g";
export var solidGreen = "_ty-b";
export var solidLightBlue = "_ty-d";
export var solidNavy = "_ty-c";
export var solidOrange = "_ty-f";
export var solidPink = "_ty-e";
export var solidRed = "_ty-9";
export var solidYellow = "_ty-a";
export var success = "_ty-4";